import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { MecordColors } from "../../../Constants/Color";

export interface ScheduleFollowUpValue {
  next_follow_up_date: string;
  follow_up_remarks: string;
}

interface ScheduleFollowUpProps {
  value: ScheduleFollowUpValue;
  onChange: (value: ScheduleFollowUpValue) => void;
  errors?: Partial<Record<keyof ScheduleFollowUpValue, any>>;
  disabled?: boolean;
  minDate?: string; // Optional min date for date input validation
}

const ScheduleFollowUp: React.FC<ScheduleFollowUpProps> = ({
  value,
  onChange,
  errors,
  disabled = false,
  minDate,
}) => {
  return (
    <div className="rounded">
      <div className="d-flex justify-content-between align-items-center gap-2">
        <h5 className="fw-semibold">Schedule Follow-up</h5>
      </div>
      <div
        className="rounded p-2 pt-3"
        style={{ backgroundColor: MecordColors?.LightGrayColor }}
      >
        <Row className="g-3">
          <Col md={12}>
            <Form.Group>
              <Form.Label>
                Next Follow Up Date<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                value={value.next_follow_up_date || ""}
                disabled={disabled}
                onChange={(e) =>
                  onChange({ ...value, next_follow_up_date: e.target.value })
                }
                placeholder="Select Follow Up Date"
                min={minDate}
                isInvalid={!!errors?.next_follow_up_date}
                onInvalid={(e: any) => {
                  if (minDate && e.target.value && new Date(e.target.value) < new Date(minDate)) {
                    e.target.setCustomValidity(`Follow up date cannot be before ${minDate}`);
                  } else {
                    e.target.setCustomValidity("");
                  }
                }}
                onInput={(e: any) => {
                  e.target.setCustomValidity("");
                }}
              />
              {errors?.next_follow_up_date ? (
                <div className="invalid-feedback d-block">
                  {typeof errors.next_follow_up_date === "string"
                    ? errors.next_follow_up_date
                    : "Next follow up date is required"}
                </div>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group>
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                style={{ maxHeight: '400px', resize: 'vertical' }}
                placeholder="Enter remarks"
                value={value.follow_up_remarks || ""}
                disabled={disabled}
                onChange={(e) =>
                  onChange({ ...value, follow_up_remarks: e.target.value })
                }
                isInvalid={!!errors?.follow_up_remarks}
              />
              {errors?.follow_up_remarks ? (
                <div className="invalid-feedback d-block">
                  {typeof errors.follow_up_remarks === "string"
                    ? errors.follow_up_remarks
                    : "Invalid remarks"}
                </div>
              ) : null}
            </Form.Group>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ScheduleFollowUp;


